<template>
   <basic-container>
      <el-row 
        type="flex"
        :gutter="20"
        style="margin-bottom:20px"
        >
        <el-col :span="6">
          <div class="grid-content">
            <p>订单号：{{tableData.orderId}}</p>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <p>门店：{{tableData.storeName}}</p>
            <p>地址：{{tableData.receiverAddress}}</p>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <p>收货人：{{tableData.receiverName}}</p>
            <p>联系方式：{{tableData.receiverPhone}}</p>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <div>
            <el-tag effect="dark">菜品金额：{{tableData.goodsAmount}}元</el-tag>
            <el-tag effect="dark">运费：{{tableData.freightAmount}}元</el-tag>
            <el-tag effect="dark">押金：{{tableData.packageAmount}}元</el-tag>
            <el-tag effect="dark">金额总计：{{tableData.orderAmount}}元</el-tag>
            <el-button size="small" @click="handleBack" style="float:right;margin-right:50px;">返回</el-button>
        <el-table v-loading="loading" :data="tableData.list">
          <el-table-column label="商品名称" align="center">
            <template slot-scope="scope">
              <el-row :gutter="0">
                <el-col :span="4"><el-avatar shape="square" fit="fill" size="medium" :src="scope.row.skuPic"></el-avatar></el-col>
                <el-col :span="20">{{scope.row.skuName}}</el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="规格" align="center" width="100px" prop="ssuFormat"></el-table-column>
          <el-table-column label="单位" align="center" width="100px" prop="skuUnit"></el-table-column>
          <el-table-column label="单价(元)" align="center" width="120px" prop="unitSsuPrice" sortable></el-table-column>
          <el-table-column label="下单量" align="center" width="100px" prop="ssuNum" sortable></el-table-column>
          <el-table-column label="商品类型" align="center" width="100px" prop="goodsType">
            <template slot-scope="scope">
              <span>{{scope.row.goodsType == 2 ? "包装物" : "商品"}}</span>
            </template>
          </el-table-column>
          <el-table-column label="小计(元)" align="center" width="120px" prop="ssuPrice" sortable></el-table-column>
          <el-table-column label="商品状态" align="center" width="100px" prop="itemStatus" sortable></el-table-column>
        </el-table>
      </div>
   </basic-container>
</template>
<script>

export default{
  data(){
    return {
      loading:false,
      orderId:null,
      storeId:null,
      tableData:{}
    }
  },
  methods:{
    handleBack() {
      this.$router.go(-1);
    },
    async getDetail() {
          this.loading = true;
          const {
            ret,
            data
          } = await _api.order.detail({
            storeId:this.storeId,
            orderId:this.orderId
          });
          if (ret && data) {
            this.tableData = data || {};
          }
          this.loading = false;
        }
  },
  created(){
    this.orderId = this.$route.query.orderId
    this.storeId = this.$route.query.storeId
    if(this.$route.query.orderId != undefined){
      this.getDetail()
    }
    
  }
}
</script>
<style>
  /* .grid-bord {
    border:0px solid#d3dce6;
  } */
  .el-row {
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 40px;
  }
  .grid-content p {
    margin-bottom: 5px;
  }
  .el-tag + .el-tag {
    margin: 10px;
  }
</style>